import { useMemo } from 'react';

export function useGameUtils() {
  const generateRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const shuffleArray = (array) => {
    return [...array].sort(() => Math.random() - 0.5);
  };

  const generateSequence = (length, start = 1, sequential = true) => {
    if (sequential) {
      return Array.from({ length }, (_, i) => start + i);
    }
    return Array.from({ length }, () => generateRandomNumber(start, start + length));
  };

  const dominoUnicode = useMemo(() => [
    '🁣', '🁤', '🁥', '🁦', '🁧', '🁨', '🁩', '🂎', '🂏', '🂐',
  ], []);

  return {
    generateRandomNumber,
    shuffleArray,
    generateSequence,
    dominoUnicode,
  };
} 